module.exports = __webpack_public_path__ + "static/media/S36_B.ecec7e11.png";